import { AppBar, Toolbar, Typography, Container, Button } from '@mui/material';
import { ReactNode } from 'react';
import styles from './Layout.module.scss';
import { useAuth } from '../../context/AuthProvider';
import { Link, useNavigate } from 'react-router-dom';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className={styles.root}>
      <AppBar position="static" className={styles.header}>
        <Toolbar className={styles.toolbar}>
          <Typography variant="h6" component="div">
            <Link to="/">
              <img src={'/logo.svg'} className={styles.logo} alt="logo" />
            </Link>
          </Typography>
          <Button
            color="inherit"
            onClick={handleLogout}
            className={styles.logoutButton}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <Container maxWidth={false} component="main" className={styles.main}>
        {children}
      </Container>
    </div>
  );
};

export default Layout;
